import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewFAQPageNew from "../../components/FAQ/ViewFAQPageNew";



const ViewFAQPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Faq" link2="/faq" title="View Faq" />

        {/* AddUserLayer */}
        <ViewFAQPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewFAQPage;
